import { SURVEY_STATUS } from '../constants/survey-status';

export class surveyPauseThresholdUpdateInspector<
  T extends {
    is_survey_pause_threshold_triggered: boolean;
    current_cpi: number;
    currency_symbol: string;
  }
> {
  constructor(
    private readonly _currentSurveyStatus: number,
    private readonly _upcomingSurveyStatus: number,
    private readonly _survey: T
  ) {}

  public check(): boolean {
    return this._status() && this._triggered();
  }

  public text(): string {
    return this.check()
      ? `Note that Pause Threshold will be updated to ${this._survey.currency_symbol}${this._survey.current_cpi}`
      : '';
  }

  private _status(): boolean {
    return (
      this._currentSurveyStatus === SURVEY_STATUS.PAUSED &&
      this._upcomingSurveyStatus === SURVEY_STATUS.LIVE
    );
  }

  private _triggered(): boolean {
    return !!this._survey.is_survey_pause_threshold_triggered;
  }
}
